import { retryOperation } from "@utils/retryOperation";
import { pageView } from "./analyticsV2";

export const openNewsletter = async () => {
  await retryOperation(async () => {
    if (!window?._klOnsite) {
      throw new Error("window._klOnsite is not defined");
    }
    window._klOnsite = window._klOnsite ?? [];
    window._klOnsite.push(["openForm", "XDeiVn"]);
  });

  await pageView.eventSubscribe();
};
